import { useEffect, useState } from "react";

export const useObservable = <T>(observable: { subscribe: (callback: (value: T) => void) => { unsubscribe: () => void } }): T => {
    const [value, setValue] = useState<T | undefined>(undefined);

    useEffect(() => {
        const subscription = observable.subscribe(setValue);
        return () => subscription.unsubscribe();
    }, [observable]);

    return value as T;
}
